import { UPDATE_SELECTOR, UPDATE_ADVERTISER_FORM } from '../actions/types';
import { formValueSelector } from 'redux-form';

export const advertiserFormSelector = formValueSelector('advertiserForm');

const initialState = {
  currentFormName: 'advertiserForm',
};
export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_SELECTOR:
      return { ...state, currentFormName: action.payload };
    case UPDATE_ADVERTISER_FORM:
      return { ...state, advertiserForm: action.payload };
    case 'set':
      return { ...state, ...action.payload };
    default:
      return state;
  }
}
